import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CompanySettingAddUpdate from "../../../modal";
import { useApiCall } from "../../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../../../component/ui/loader/data-not-found";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../../../component/table/table-layout";
import DynamicFilter from "../../../../../../component/table/filter-table/dynamic-filter";
import CustomizeTabsPopup from "../../../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../../../component/icons/layout-top";
import FilterFunnel01Icon from "../../../../../../component/icons/filter-funnel-01";
import Tooltip from "../../../../../../component/ui/tooltip";
import NewEditIcon from "../../../../../../component/icons/action-edit-icon";
import AvatarProfile from "../../../../../../component/ui/profile";

const SettingsBrands = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);

  const [currentData, setCurrentData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({ filter = filterReturn }) => {
    setIsLoading(true);
    const extraUrl =
      filter?.length > 0
        ? "?" +
          filter
            .map(
              (f) =>
                `${encodeURIComponent(f.name)}=${encodeURIComponent(f.value)}`,
            )
            .join("&")
        : "";

    try {
      const res = await apiCall({
        method: "get",
        url: `brands/brands-list${extraUrl}`,
      });

      setApiData(res?.data);

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowEditModal(false);
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editBrand = (data) => {
    setCurrentData(data);
    setShowEditModal(true);

    console.log("Brand Data", data);
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {/* filter div */}
                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(allFilter) => {
                      setFilterReturn(allFilter);
                      getData({ filter: allFilter });
                    }}
                  />
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          filterReturn?.length ? Style.active : null
                        }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Brands"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Name</span>
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <div className="flex gap-4 items-center">
                                <span>Email</span>
                              </div>
                            </TableCell>
                            <TableCell header>
                              <div className="flex gap-4 items-center">
                                <span>Phone</span>
                              </div>
                            </TableCell>
                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                              eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null,
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    {eachList?.logo ? (
                                      <>
                                        {/* <div className="flex items-center gap-3">
                                          <div>
                                            {eachList?.logo && (
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.brandname?.split(
                                                  " "
                                                )[0]
                                                  ? eachList?.brandname?.split(
                                                      " "
                                                    )[0][0]
                                                  : ""}
                                                {eachList?.brandname?.split(
                                                  " "
                                                )[1]
                                                  ? eachList?.brandname?.split(
                                                      " "
                                                    )[1][0]
                                                  : ""}
                                              </div>
                                            )}
                                          </div>
                                          <div className="font-medium leading-5">
                                            {eachList?.brandname}
                                          </div>
                                        </div> */}

                                        <AvatarProfile
                                          src={eachList?.brandname}
                                          title={eachList?.brandname}
                                        />

                                        <div
                                          className={
                                            Style.tableActionAreaBtnGrpup
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => {
                                              editBrand(eachList);
                                            }}
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#FF9500" }}
                                            >
                                              <NewEditIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  {eachList?.meta?.email ? (
                                    <a
                                      href={`mailto:${eachList?.meta?.email}`}
                                      className="text-blue-600 hover:underline"
                                    >
                                      {eachList?.meta?.email}
                                    </a>
                                  ) : (
                                    "--"
                                  )}
                                </TableCell>
                                <TableCell>
                                  {eachList?.meta?.phone ?? "--"}
                                </TableCell>
                                {/* <TableCell>
                                  {(() => {
                                    const email = eachList?.meta?.find(
                                      (m) => m.meta_key === "email"
                                    )?.meta_value;

                                    return email ? (
                                      <a
                                        href={`mailto:${email}`}
                                        className="text-blue-600 hover:underline"
                                      >
                                        {email}
                                      </a>
                                    ) : (
                                      "--"
                                    );
                                  })()}
                                </TableCell>
                                <TableCell>
                                  {(() => {
                                    const phone = eachList?.meta?.find(
                                      (m) => m.meta_key === "phone"
                                    )?.meta_value;

                                    return phone ? phone : "--";
                                  })()}
                                </TableCell> */}
                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead?.show == 1 ? (
                                    <>
                                      {eachHead.key === "brandurl" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList?.brandurl ? (
                                            <a
                                              href={eachList.brandurl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="text-blue-600 hover:underline"
                                            >
                                              {eachList.brandurl}
                                            </a>
                                          ) : (
                                            "--"
                                          )}
                                        </TableCell>
                                      ) : eachHead.key === "logo" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList?.logo ? (
                                            <a
                                              href={eachList.logo}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="inline-flex items-center justify-center"
                                            >
                                              <img
                                                src={eachList.logo}
                                                alt="Brand Logo"
                                                className="w-10 h-10 object-contain rounded"
                                                onError={(e) =>
                                                  (e.target.style.display =
                                                    "none")
                                                }
                                              />
                                            </a>
                                          ) : (
                                            "--"
                                          )}
                                        </TableCell>
                                      ) : (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList[eachHead.key] ?? "--"}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : null,
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${
                        tablePagination?.total || apiData?.length
                      }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              // setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              // filterData({ page: pageCount + 1, btnCall: true });
                              getData({
                                page: tablePagination?.next_page_url,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showEditModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setShowEditModal(false);
          }}
          data={currentData}
          onSubmit={onSuccess}
          onError={onError}
          tabIndex={0}
        />
      )}
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="brands/brands-list"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="brands/brands-list"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SettingsBrands;
